import React, { useEffect } from 'react'
import './Details.css';
import "swiper/css";
import nuser from "../../images/nuser.jpg"
import dtls from "../../images/dtls.jpg"
import dtls2 from "../../images/dtls2.jpg"
import logo from "../../images/logo2.png"
import { useDispatch } from 'react-redux';
import { setHeaderType } from '../../Redux/ActionCreater';


function Details() {
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(setHeaderType(2))
    },[])
    return (
        <>
     {/* <header className="headercontainer detailhedr">
        <div className="container">
          <div className="row align-items-center">
            <div className="logoouter">
              <div className="logo">
                <a href="/bitnix"><img src={logo} alt /></a>
              </div>
            </div>
            <div className="navigation">
              <div className="navigationouter">
                <div className="navigationbox">
                  <div className="navuser">
                    <div className="userimg">
                      <img src={logo} alt="Logo" />
                    </div>
                  </div>
                  <div className="sf-menu-outer">
                    <ul className="sf-menu">
                      <li className=""><a href="/bitnix">Home</a></li>
                      <li className=""><a href="/bitnix/collect-my-waste">Collect My waste</a></li>
                      <li><a href="/bitnix">Clients</a></li>
                      <li className=""><a href="/bitnix/impact">Impact</a></li>
                      <li className=""><a href="/bitnix/about-us">About us</a></li>
                      <li><a href="/bitnix">Press &amp; Blogs</a></li>
                      <li><a href="/bitnix">Contact Us</a></li>
                    </ul>
                  </div>
                </div>
                <div className="loginbtx">
                  <a href="/bitnix" >Login To The App</a>
                </div>
                <a className="NavBar" href="/bitnix"><i className="icon icon-segment" /></a>
              </div>
            </div>
          </div>
        </div>
      </header> */}


            <section className='details-sec'>
                <div className='container'>
                    <div className='detaslheding'>
                        <span>Technology</span>
                        <h3>The Impact of Technology on the Workplace: How Technology is Changing</h3>
                        <div className='media'>
                            <div className='mediapic'><img src={nuser} alt='demo'/></div>
                            <div className='media-object'>
                                <em>Tracey Wilson<i>August 20, 2022</i></em>
                            </div>
                        </div>
                        <div className='detailspic'>
                            <img src={dtls} alt='demo'/>
                        </div>

                        <p>Traveling is an enriching experience that opens up new horizons, exposes us to different cultures,
                            and creates memories that last a lifetime. However, traveling can also be stressful and overwhelming, especially if you don't plan and prepare adequately.
                            In this blog article, we'll explore tips and tricks for a memorable journey and how to make the most of your travels.</p>
                        <p>One of the most rewarding aspects of traveling is immersing yourself in the local culture and customs.
                            This includes trying local cuisine, attending cultural events and festivals, and interacting with locals.
                            Learning a few phrases in the local language can also go a long way in making connections and showing respect.</p>

                        <h4>Research Your Destination</h4>
                        <p>Before embarking on your journey, take the time to research your destination. This includes understanding the local culture, customs, and laws, as well as
                            identifying top attractions, restaurants, and accommodations. Doing so will help you navigate your destination with confidence and avoid any cultural faux pas.</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In hendrerit gravida rutrum quisque non
                            tellus orci ac auctor. Mi ipsum faucibus vitae aliquet nec ullamcorper sit amet. Aenean euismod elementum nisi quis eleifend quam adipiscing vitae. Viverra adipiscing at in tellus.</p>

                        <h4>Plan Your Itinerary</h4>

                        <p>While it's essential to leave room for spontaneity and unexpected adventures, having a rough itinerary can help you make the most of your time and budget. Identify the must-see sights
                            and experiences and prioritize them according to your interests and preferences. This will help you avoid overscheduling and ensure that you have time to relax and enjoy your journey.</p>
                        <p>Vitae sapien pellentesque habitant morbi tristique. Luctus venenatis lectus magna fringilla. Nec ullamcorper sit amet risus nullam eget felis. Tincidunt arcu non sodales neque sodales ut
                            etiam sit amet.</p>

                        <div className='quotetxt'>
                            <i>“ Traveling can expose you to new environments and potential health risks, so it's crucial to take precautions to stay safe and healthy. ”</i>
                        </div>    

                        <div className='detailspic'>
                            <img src={dtls2} alt='demo'/>
                        </div>

                        <h4>Pack Lightly and Smartly</h4>
                        <p>Packing can be a daunting task, but with some careful planning and smart choices, you can pack light and efficiently. Start by making a packing list and sticking to it, focusing on versatile and comfortable clothing that can be mixed and matched. Invest in quality luggage and packing organizers to maximize space and minimize wrinkles.</p>

                        <h4>Stay Safe and Healthy</h4>
                        <p>Traveling can expose you to new environments and potential health risks, so it's crucial to take precautions to stay safe and healthy. This includes researching any required vaccinations or medications, staying hydrated, washing your hands frequently, and using sunscreen and insect repellent. It's also essential to keep your valuables safe and secure and to be aware of your surroundings at all times.</p>

                        <h4>Immerse Yourself in the Local Culture</h4>
                        <p>One of the most rewarding aspects of traveling is immersing yourself in the local culture and customs. This includes trying local cuisine, attending cultural events and festivals, and interacting with locals. Learning a few phrases in the local language can also go a long way in making connections and showing respect.</p>

                        <h4>Capture Memories</h4>
                        <p>Finally, don't forget to capture memories of your journey. Whether it's through photographs, journaling, or souvenirs, preserving the moments and experiences of your travels can bring joy and nostalgia for years to come. However, it's also essential to be present in the moment and not let technology distract you from the beauty of your surroundings.</p>


                        <h4>Conclusion:</h4>
                        <p>Traveling is an art form that requires a blend of planning, preparation, and spontaneity. By following these tips and tricks, you can make the most of your journey and create memories that last a lifetime. So pack your bags, embrace the adventure, and enjoy the ride.</p>

                    </div>
                </div>
            </section>






        </>

    )
}

export default Details